(function () {
  const SECTION_SELECTOR =
    '.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group)';

  function initializeScrollReveal(container = document) {
    const sections = container.querySelectorAll(SECTION_SELECTOR);

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      sections.forEach((section) => {
        section.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    sections.forEach((section) => {
      if (section.dataset.scrollRevealInitialized === 'true') return;

      section.dataset.scrollRevealInitialized = 'true';
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeScrollReveal();
    });
  } else {
    initializeScrollReveal();
  }

  /*
   * Reinitialize sections added or refreshed inside
   * Shopify's theme customizer.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollReveal(event.target);
  });
})();